const schools = {
  schools: "Schools",
  school: "School",
  schoolName: "School name",
  schoolAddress: "School address",
  schoolDetail: "School detail",
  schoolStatus: "Status",
  schoolStatusProspect: "Prospect",
  schoolStatusContract: "Contract",
  schoolIsPrepaidStudentSubscriptions: "Student subscription",
  schoolContact: "Contact",
  purgeSelection: "Delete selected schools data",
  purgeWarning:
    "All classes, assignments and associated data will be permanently deleted.",
  clickToDeleteSchool:
    "Check this box to remove the school from the database as well.",
  clickToDeleteSchools:
    "Check this box to remove the schools from the database as well.",
  numberSelected: "Number of selected schools:",
  purgeSingleSchool: "Purge this school?",
  purgeSchool: "Purge this school",
  establishment: "Establishment",
  establishments: "Schools",
  establishmentsAndClasses: "Schools and classes",
};

export default schools;
